/**
 * Stable identity for a tree node across reloads.
 *
 * `id` on tree data is a per-response sequence counter, so it shifts whenever a node is added,
 * moved or removed. `nodeId` is the database key; `type` and `documentType` keep folders and
 * files from different tables from colliding.
 */
export function treeNodeKey(data: any): string {
  return `${data?.type}:${data?.documentType}:${data?.nodeId}`;
}
